module.exports = __webpack_public_path__ + "img/edit-temp.c63eb8a1.png";